import { ContextState } from './context/ContextState'
import { DashboardState } from './dashboard/DashboardState'
import { ErrorsState } from './errors/ErrorsState'
import { EventsState } from './events/EventsState'
import { MonitorState } from './monitor/MonitorState'
import { OperationsState } from './operations/OperationsState'
import { ProfilesState } from './profiles/ProfilesState'
import { SnapshotState } from './snapshots/SnapshotState'
import { TracesState } from './traces/TracesState'
import { V2State } from './V2/V2State'
import { FeatureFlags } from '../php-exports.generated.constants'

export interface ApplicationState {
    tidewaysContext: ContextState
    v2: V2State
    errors: ErrorsState
    operations: OperationsState
    profiles: ProfilesState
    monitor: MonitorState
    dashboard: DashboardState
    events: EventsState
    snapshots: SnapshotState
    traces: TracesState
}

export const getV2State = (state: ApplicationState) => state.v2

type ObjectValues<T> = T[keyof T]
export type PossibleFeatureFlags = ObjectValues<typeof FeatureFlags>

export const isFeatureEnabled = (state: ApplicationState, feature: PossibleFeatureFlags): boolean => {
    const user = state.tidewaysContext?.router?.user
    const organization = state.tidewaysContext?.organization

    if (!user && !organization) {
        return false
    }

    if (user?.features?.includes(feature)) {
        return true
    }

    if (organization?.features?.includes(feature)) {
        return true
    }

    return false
}
